var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { hideApplicationLoader, showApplicationLoader, } from 'common/ApplicationLoader';
import { API } from 'globals/api';
import { TEMPLATE_END_POINTS } from 'globals/apiEndPoints';
import { DIALOG_TYPES } from 'globals/global.constants';
import { openOverlayDialog, showError } from 'store/commonReducer/common.action';
export var postTaskListService = function (data) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 4]);
                return [4 /*yield*/, API({
                        url: TEMPLATE_END_POINTS.POST_SBAR_TEMPLATE,
                        method: 'put',
                        data: data,
                    })];
            case 1:
                response = _a.sent();
                return [4 /*yield*/, dispatch(openOverlayDialog({
                        type: DIALOG_TYPES.SUCCESS,
                        firstMessage: response === null || response === void 0 ? void 0 : response.message,
                    }))];
            case 2:
                _a.sent();
                return [2 /*return*/, response];
            case 3:
                error_1 = _a.sent();
                dispatch(showError(error_1));
                throw error_1;
            case 4: return [2 /*return*/];
        }
    });
}); }; };
export var getTemplates = function (params) { return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                dispatch(showApplicationLoader());
                _a.label = 1;
            case 1:
                _a.trys.push([1, 4, 5, 6]);
                return [4 /*yield*/, API({
                        url: TEMPLATE_END_POINTS.GET_SBAR_TEMPLATE,
                        method: 'get',
                        params: params,
                    })];
            case 2: return [4 /*yield*/, _a.sent()];
            case 3:
                response = _a.sent();
                return [2 /*return*/, {
                        data: (response === null || response === void 0 ? void 0 : response.data) || [],
                        lastEvaluatedKey: (response === null || response === void 0 ? void 0 : response.last_evaluated_key) || null,
                    }];
            case 4:
                error_2 = _a.sent();
                dispatch(showError(error_2));
                throw error_2;
            case 5:
                dispatch(hideApplicationLoader());
                return [7 /*endfinally*/];
            case 6: return [2 /*return*/];
        }
    });
}); }; };
export var getTemplatesHistory = function (params) { return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_3;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                dispatch(showApplicationLoader());
                _a.label = 1;
            case 1:
                _a.trys.push([1, 4, 5, 6]);
                return [4 /*yield*/, API({
                        url: TEMPLATE_END_POINTS.GET_TEMPLATE_HISTORY,
                        method: 'get',
                        params: params,
                    })];
            case 2: return [4 /*yield*/, _a.sent()];
            case 3:
                response = _a.sent();
                return [2 /*return*/, {
                        data: (response === null || response === void 0 ? void 0 : response.data) || [],
                        lastEvaluatedKey: (response === null || response === void 0 ? void 0 : response.last_evaluated_key) || null,
                    }];
            case 4:
                error_3 = _a.sent();
                dispatch(showError(error_3));
                throw error_3;
            case 5:
                dispatch(hideApplicationLoader());
                return [7 /*endfinally*/];
            case 6: return [2 /*return*/];
        }
    });
}); }; };
export var getActiveTemplates = function (params) { return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_4;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                dispatch(showApplicationLoader());
                _a.label = 1;
            case 1:
                _a.trys.push([1, 4, 5, 6]);
                return [4 /*yield*/, API({
                        url: TEMPLATE_END_POINTS.GET_ACTIVE_TEMPLATES,
                        method: 'get',
                        params: params,
                    })];
            case 2: return [4 /*yield*/, _a.sent()];
            case 3:
                response = _a.sent();
                return [2 /*return*/, {
                        data: (response === null || response === void 0 ? void 0 : response.data) || [],
                        lastEvaluatedKey: (response === null || response === void 0 ? void 0 : response.last_evaluated_key) || null,
                    }];
            case 4:
                error_4 = _a.sent();
                dispatch(showError(error_4));
                throw error_4;
            case 5:
                dispatch(hideApplicationLoader());
                return [7 /*endfinally*/];
            case 6: return [2 /*return*/];
        }
    });
}); }; };
export var postArchiveTemplates = function (data) { return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_5;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                dispatch(showApplicationLoader());
                _a.label = 1;
            case 1:
                _a.trys.push([1, 5, 6, 7]);
                return [4 /*yield*/, API({
                        url: TEMPLATE_END_POINTS.ARCHIVE_TEMPLATE,
                        method: 'put',
                        data: data,
                    })];
            case 2: return [4 /*yield*/, _a.sent()];
            case 3:
                response = _a.sent();
                return [4 /*yield*/, dispatch(openOverlayDialog({
                        type: DIALOG_TYPES.SUCCESS,
                        firstMessage: response === null || response === void 0 ? void 0 : response.message,
                    }))];
            case 4:
                _a.sent();
                return [2 /*return*/, {
                        data: (response === null || response === void 0 ? void 0 : response.data) || [],
                        lastEvaluatedKey: (response === null || response === void 0 ? void 0 : response.last_evaluated_key) || null,
                    }];
            case 5:
                error_5 = _a.sent();
                dispatch(showError(error_5));
                throw error_5;
            case 6:
                dispatch(hideApplicationLoader());
                return [7 /*endfinally*/];
            case 7: return [2 /*return*/];
        }
    });
}); }; };
